// //import {Route, Routes} from 'react-router-dom'
import { Routes, Route } from 'react-router-dom';
import './App.css';

//import ProtectedRoute from './Components/ProtectedRoute';
import Landing from './Components/landingsc';
import Home from './Components/home';
import Insurance from './Components/Insurance';
// import Rudra from './Components/rudra';
import NewHome from './Components/newhome';
import Login from './Components/login';
import FrameHome from './Components/framehome';
import MutualFunds from './Components/MutualFunds';
import NotFound from './Components/NotFound';
import DematAccount from './Components/DematAccount';
import Working from './Components/Working';
import OfflinePage from './Components/offline';
import Dashboard from './Components/Dashboard';
import Ticket from './Components/Ticket';
import AboutUs from './Components/About';

const App = () => (
  <Routes>
    <Route exact path="/" element={<FrameHome />} />
    <Route exact path="/home" element={<Home />} />
    <Route exact path="/insurance" element={<Working />} />
    {/* <Route exact path="/new" element={<NewHome />} /> */}
    <Route exact path="/login" element={<Login />} />
    {/* <Route exact path="/framehome" element={<FrameHome />} /> */}
    <Route exact path="/mutualfunds" element={<MutualFunds />} />
    <Route exact path="/demataccount" element={<DematAccount />} />
    <Route exact path="/pms" element={<Working />} />
    <Route exact path="/loans" element={<Working />} />
    <Route exact path="/fixeddeposits" element={<Working />} />
    <Route exact path="/fixeddeposit" element={<Working />} />
    <Route exact path="/nri/demat" element={<OfflinePage />} />
    <Route exact path="/oci/demat" element={<OfflinePage />} />
    <Route exact path="/dashboard" element={<Dashboard />} />
    <Route exact path="/ticket/:id" element={<Ticket />} />
    <Route exact path="/aboutus" element={<AboutUs />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
)


// import TestCheck from "./Components/test";
// import { GoogleOAuthProvider } from "@react-oauth/google";

// const App = () => {
//   return (
//     <GoogleOAuthProvider clientId="65624971031-c79iip89339fj189hsosb2ej9atepf83.apps.googleusercontent.com">
//       <TestCheck />
//     </GoogleOAuthProvider>
//   );
// };

export default App;
